import bizNodeModel from '../../bizNodeModel.mjs'

export default bizNodeModel({
    text: {
        name: () => '标题',
    },
})
